import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const submitReport = async ({ entityType, entityId, reason, description }) => {
  const response = await axios.post(apiRoutes.REPORT_ENTITY, {
    entityType,
    entityId,
    reason,
    description: description || undefined,
  });
  return response.data;
};
